import { Link } from 'react-router-dom';
function PrivacyPolicy() {
    return (
        <div  style={{backgroundColor:'white'}}>
        {/*Page Header Start*/}
<section className="page-header">
<div
  className="page-header__bg"
  style={{
    backgroundImage: "url(assets/images/backgrounds/slider-1-2.jpg)"
  }}
></div>
<div className="container">
  <div className="page-header__inner">
    <h2>Privacy Policy</h2>
    <div className="thm-breadcrumb__box">
      <ul className="thm-breadcrumb list-unstyled">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <span className="icon-arrow-left" />
        </li>
        <li>Privacy Policy</li>
      </ul>
    </div>
  </div>
</div>
</section>

<div className="container" style={{paddingTop:'40px', paddingBottom:"30px"}} >
<div className="section-title text-center" style={{ marginBottom: 0 }}>
        <div className="section-title__tagline-box">
          <span className="section-title__tagline" style={{ color: "black" }}>
          Privacy Policy
          </span>
        </div>
        <br />
        <img
          alt=""
          loading="lazy"
          width={97}
          height={13}
          decoding="async"
          data-nimg={1}
          style={{ color: "transparent" }}
          src="assets/images/svg/separator.eb50640e.svg"
        />
      </div>
      <div className="">
        <p><b>Privacy Policy:</b>
        </p>
        <p>
        INFORMATION GATHERED BY <Link to="https://rizchauffeur.com">rizchauffeur.com</Link>.
         This is <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> ’s (“<Link to="https://rizchauffeur.com">rizchauffeur.com</Link> ”) online privacy policy (“Policy”). This policy applies only to activities <Link to="https://rizchauffeur.com">rizchauffeur.com</Link>  engages in on its website and does not apply to <Link to="https://rizchauffeur.com">rizchauffeur.com</Link>  activities that are "offline" or unrelated to the website.
        </p>
        </div>
        <p style={{paddingTop:'20px'}}>
        <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> collects certain anonymous data regarding the usage of the website. This information does not personally identify users, by itself or in combination with other information, and is gathered to improve the performance of the website. The anonymous data collected by the <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> website can include information such as the type of browser you are using, and the length of the visit to the website. You may also be asked to provide personally identifiable information on the <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> website, which may include your name, address, telephone number and e-mail address. This information can be gathered when feedback or e-mails are sent to <Link to="https://rizchauffeur.com">rizchauffeur.com</Link>, when you register for services, or make purchases via the website. In all such cases you have the option of providing us with personally identifiable information.
        </p>
        
        <p style={{ paddingTop:'20px'}}>
        1. USE AND DISCLOSURE OF INFORMATION
          <p style={{paddingLeft:'20px'}}>
          Except as otherwise stated below, we do not sell, trade or rent your personally identifiable information collected on the site to others. The information collected by our site is used to process orders, to keep you informed about your order status, to notify you of products or special offers that may be of interest to you, and for statistical purposes for improving our site. We will disclose your Delivery information to third parties for order tracking purposes or process your check or money order, as appropriate, fill your order, improve the functionality of our site, perform statistical and data analyses deliver your order and deliver promotional emails to you from us. For example, we must release your mailing address information to the delivery service to deliver products that you ordered.
             </p>
        </p>
        <p style={{ paddingTop:'20px'}}> All credit/debit cards’ details and personally identifiable information will NOT be stored, sold, shared, rented or leased to any third parties</p>
        <p style={{ paddingTop:'20px'}}>
        2. COOKIES
          <p style={{paddingLeft:'20px'}}>
          Cookies are small bits of data cached in a user’s browser. <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> utilizes cookies to determine whether or not you have visited the home page in the past. However, no other user information is gathered.
          <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> may use non-personal "aggregated data" to enhance the operation of our website, or analyze interest in the areas of our website. Additionally, if you provide <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> with content for publishing or feedback, we may publish your user name or other identifying data with your permission.
             </p>
             <p style={{paddingLeft:'20px'}}>
             <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> may also disclose personally identifiable information in order to respond to a subpoena, court order or other such request. <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> may also provide such personally identifiable information in response to a law enforcement agencies request or as otherwise required by law. Your personally identifiable information may be provided to a party if <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> files for bankruptcy, or there is a transfer of the assets or ownership of <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> in connection with proposed or consummated corporate reorganizations, such as mergers or acquisitions.
             </p>
        </p>
        <p style={{ paddingTop:'20px'}}>
        3.SECURITY
          <p style={{paddingLeft:'20px'}}>
          <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> takes appropriate steps to ensure data privacy and security including through various hardware and software methodologies. However, <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> cannot guarantee the security of any information that is disclosed online.
             </p>
        </p>
        <p style={{ paddingTop:'20px'}}>
        4.OTHER WEBSITES
          <p style={{paddingLeft:'20px'}}>
          <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> is not responsible for the privacy policies of websites to which it links. If you provide any information to such third parties different rules regarding the collection and use of your personal information may apply. We strongly suggest you review such third party’s privacy policies before providing any data to them. We are not responsible for the policies or practices of third parties. Please be aware that our sites may contain links to other sites on the Internet that are owned and operated by third parties. The information practices of those Web sites linked to our site is not covered by this Policy. These other sites may send their own cookies or clear GIFs to users, collect data or solicit personally identifiable information. We cannot control this collection of information. You should contact these entities directly if you have any questions about their use of the information that they collect.
             </p>
        </p>
        <p style={{ paddingTop:'20px'}}>
        5.MINORS
          <p style={{paddingLeft:'20px'}}>
          <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> 
          does not knowingly collect personal information from minors under the age of 18. Minors are not permitted to use the <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> website or services, and <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> requests that minors under the age of 18 not submit any personal information to the website. Since information regarding minors under the age of 18 is not collected, <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> does not knowingly distribute personal information regarding minors under the age of 18.
CORRECTIONS AND UPDATES. If you wish to modify or update any information <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> has received, please contact booking@rizchauffeur.com
             </p>
        </p>
        <p style={{ paddingTop:'20px'}}>
        6.MODIFICATIONS OF THE PRIVACY POLICY
          <p style={{paddingLeft:'20px'}}>
          <Link to="https://rizchauffeur.com">rizchauffeur.com</Link> . The Website Policies and Terms & Conditions would be changed or updated occasionally to meet the requirements and standards. Therefore the Customers’ are encouraged to frequently visit these sections in order to be updated about the changes on the website. Modifications will be effective on the day they are posted”.

             </p>
        </p>
</div>


 {/* /.page-wrapper */}
 <div className="mobile-nav__wrapper">
    <div className="mobile-nav__overlay mobile-nav__toggler" />
    {/* /.mobile-nav__overlay */}
    <div className="mobile-nav__content">
      <span className="mobile-nav__close mobile-nav__toggler">
        <i className="fa fa-times" />
      </span>
      <div className="logo-box">
        <a href="/" style={{ paddingLeft: "0PX" }}>
          <img
            src="assets/images/resources/logosmall.png"
            height="80px"
            style={{ marginLeft: "-40px" }}
            alt=""
          />
        </a>
      </div>
      {/* /.logo-box */}
      <div className="mobile-nav__container" />
      {/* /.mobile-nav__container */}
      <ul className="mobile-nav__contact list-unstyled">
        <li>
          <i className="fa fa-envelope" />
          <a href="mailto:needhelp@packageName__.com">
            booking@rizchauffeur.com
          </a>
        </li>
        <li>
          <i className="fa fa-phone-alt" />
          <a href="tel:+971506893589">+971 506893589</a>
        </li>
      </ul>
      {/* /.mobile-nav__contact */}
      <div className="mobile-nav__top">
        <div className="mobile-nav__social">
          <a href="#" className="fab fa-twitter" />
          <a href="#" className="fab fa-facebook-square" />
          <a href="#" className="fab fa-pinterest-p" />
          <a href="#" className="fab fa-instagram" />
        </div>
        {/* /.mobile-nav__social */}
      </div>
      {/* /.mobile-nav__top */}
    </div>
    {/* /.mobile-nav__content */}
  </div>
  {/* /.mobile-nav__wrapper */}
  
  <div className="scroll-to-top">
    <svg className="scroll-top-inner" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
</div>
</div>
    )
};
export default PrivacyPolicy;